import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput ,MDBDataTable  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'

export default class Modaladdlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  loading:false,





   name_workorder:'',

   code:'',
   id_workorder:'',
   name_worklist:'',
   num_worklist:'',
   price_worklist:'',
   description_worklist:'',
   material_worklist:'',
   materialvinyl_worklist:'',
   papertype_worklist:'',
   statecut_worklist:'',
   status_worklist:'1',

   worklistdata:[],
   





}

//this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
//this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.handleChange4 = this.handleChange4.bind(this);
this.handleChangefile = this.handleChangefile.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.onChangetype = this.onChangetype.bind(this);
this.onClick = this.onClick.bind(this);
this.onClickmaterialvinyl = this.onClickmaterialvinyl.bind(this);
this.onClickpapertype = this.onClickpapertype.bind(this);
this.onClickstatecut = this.onClickstatecut.bind(this);
this.getworklist = this.getworklist.bind(this);
this.resetdata = this.resetdata.bind(this);


}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.setState({ id_workorder:this.props.id_workorder})
  
 this.getworklist();
}

handleChangefile(event) {    this.setState({example_workorder: event.target.files[0]});  }

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

onChangetype(value) {
  this.setState({ paymentstatus_workorder:value})
}

onClick = (nr) => () => {
  this.setState({
    material_worklist: nr,
  });
};

onClickmaterialvinyl = (nr) => () => {
  this.setState({
    materialvinyl_worklist: nr,
  });
};

onClickpapertype = (nr) => () => {
  this.setState({
    papertype_worklist: nr,
  });
};

onClickstatecut = (nr) => () => {
  this.setState({
    statecut_worklist: nr,
  });
};

getworklist (){
    const {id_workorder} = this.state.id_workorder
    api.get('selectworklistshow.php?id_workorder='+this.props.id_workorder)
    .then(res => {
    //  console.log(res);
      this.setState({ worklistdata: res.data, loading: false })
    //  this.setState({ NAME: res.data[0].NAME})
    //  this.setState({ PNAME: res.data[0].PNAME})
     // this.setState({ FACULTY: res.data[0].FACULTY})
    }) 
}





 componentDidMount() {
     // const { code } = this.props.code
   //   console.log(id_send);
     this.setState({ code:this.props.code})
     this.setState({ name_workorder:this.props.name_workorder})
     this.setState({ id_workorder:this.props.id_workorder})
    
     

  }

    resetdata() {
    setTimeout(() => {
      //ภายใน 
      this.setState({
        name_worklist: '',
        num_worklist:'',
        price_worklist:'',
        description_worklist:'',
        material_worklist:'',
        materialvinyl_worklist:'',
        papertype_worklist:'',
        statecut_worklist:'',
    })
     

    }, 0);

}

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


 // handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
 // handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
 // handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit(e) {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("code_workorderlist", this.state.code);
      datafrm.append("id_workorderlist", this.state.id_workorder);
      datafrm.append("name_worklist", this.state.name_worklist);
      datafrm.append("num_worklist", this.state.num_worklist);
      datafrm.append("price_worklist", this.state.price_worklist);
      datafrm.append("description_worklist", this.state.description_worklist);
      datafrm.append("material_worklist", this.state.material_worklist);
      datafrm.append("materialvinyl_worklist", this.state.materialvinyl_worklist);
      datafrm.append("papertype_worklist", this.state.papertype_worklist);
      datafrm.append("statecut_worklist", this.state.statecut_worklist);
      datafrm.append("status_worklist", this.state.status_worklist);

    
      
      api.post("insertworklist.php",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })

   .then(res => {
  
    if (res.status=== 200) {
        Swal.fire({
            title: 'บันทึกรายการสำเร็จ',
            icon: 'success',
          // showCancelButton: true,
            confirmButtonText: 'ตกลง',
          // cancelButtonText: 'No, keep it'
          }).then((result) => {
          //  this.toggle();  
          this.getworklist();
            this.resetdata();
          })
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })


//อัพเดทสถานะ
  // Axios
  // // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  //   .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
  //   .then(res => {
  //     console.log("response: ", res)
 
  //     if (res.data.length !== 0) {
  //      // this.showitem = true;
  //       console.log(res)
  //       console.log(res.data.length)
  //    }else{
  //     // window.location.href = '/'
  //    }
  //    this.toggle()
  //  })
  // this.toggle()


}, 1000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 


  }




 

  

    render() {

console.log(this.state.code)
console.log(this.state.id_workorder)
console.log(this.state.name_worklist)
console.log(this.state.num_worklist)
console.log(this.state.price_worklist)
console.log(this.state.description_worklist)
console.log(this.state.material_worklist)
console.log(this.state.materialvinyl_worklist)
console.log(this.state.papertype_worklist)
console.log(this.state.statecut_worklist)
console.log(this.state.status_worklist)



const data = {
    columns: [
      {
        label: 'ลำดับ',
        field: 'list',
        sort: 'list',
        width: 150
      },
      {
        label: 'รายการ',
        field: 'OLDID',
        sort: 'OLDID',
        width: 270
      },
      {
        label: 'จำนวน',
        field: 'NAME',
        sort: 'NAME',
        width: 200
      },
       {
        label: 'ราคา',
        field: 'DATES',
        sort: 'DATES',
        width: 200
      },
      {
        label: 'วันที่เพิ่ม',
        field: 'FACULTY',
        sort: 'FACULTY',
        width: 100
      },
      {
        label: 'ตรวจสอบ',
        field: 'check',
        sort: 'check',
        width: 100
      }

    ],

    rows: [...this.state.worklistdata.map((data, i) => (
      {
         list: <>{i+1}</>,
         OLDID: <>{data.name_worklist}</>,
         NAME: <>{data.num_worklist}</>,
         DATES: <>{data.price_worklist}</>,
         FACULTY: <>{data.dateadd_worklist}</>,
         check: <> <MDBBtn color="amber" size="sm"  >แก้ไข</MDBBtn></>,

        //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

      }
     ))] 

};


const persons = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={20}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>



//console.log("1".padStart(5, "0"));
        return (
            <>
            <MDBBtn onClick={this.toggle} color="mdb-color" size="sm"><MDBIcon far icon="plus-square" /> เพิ่มรายการ</MDBBtn>

            
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
              <MDBModalHeader toggle={this.toggle} className="text-center"><MDBIcon icon="align-left" /> เพิ่มรายการใบสั่งงาน</MDBModalHeader><br/>
              {/* <div className="text-center"><h4>ร้านลูกแม่น้ำปิงไวนิล 055-023245, 092-5583982, 0827730380</h4></div> */}
              
            
              <MDBModalBody className="text-left">
              <div>
              <MDBAlert color="primary" >
                <h5 className="text-left"> รหัสใบสั่งงาน : {this.state.code}</h5>   <br/>
                <h5 className="text-left"> ชื่อใบสั่งงาน : {this.state.name_workorder}</h5> 
              </MDBAlert>
                  <br/>
                
              <form onSubmit={this.handleSubmit}>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> รายการ </label>
                                <input className="form-control" onChange={this.onTextChange} name="name_worklist"
                                    value={this.state.name_worklist} placeholder="" required />
                            </div>
                            <MDBRow>
                              <MDBCol md="4">
                                 <div className="mb-2">
                                   <label className="font-weight-bold"><MDBIcon icon="braille" /> จำนวน </label>
                                   <input className="form-control" onChange={this.onTextChange} name="num_worklist"
                                    value={this.state.num_worklist} placeholder="" required />
                                 </div>
                                </MDBCol>
                              <MDBCol md="4">
                                  <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="donate" /> ราคา</label>
                                      <input className="form-control" onChange={this.onTextChange} name="price_worklist"
                                          value={this.state.price_worklist} placeholder="" required />
                                  </div>
                              </MDBCol>
                            </MDBRow>
                            {/* <Divider orientation="left" plain>
                            Left Text
                            </Divider> */}

                            <MDBRow>
                              <MDBCol md="12">
                                <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="indent" /> รายละเอียด</label>
                                  <textarea className="form-control" type="text" onChange={this.onTextChange} name="description_worklist"
                                      value={this.state.description_worklist} placeholder="" required />
                                </div>
                              </MDBCol>
                            </MDBRow>
                                       
                            <MDBRow>
                              <MDBCol md="6">
                                <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="cubes" /> ประเภทวัสดุ</label>
                                   <MDBFormInline>
                                          <MDBInput
                                            gap
                                            onClick={this.onClick('ไวนิล')}
                                            checked={this.state.material_worklist === 'ไวนิล' ? true : false}
                                            label="ไวนิล"
                                            type="radio"
                                            id="radio1"
                                            containerClass="mr-5"
                                          />
                                          <MDBInput
                                            gap
                                            onClick={this.onClick('สติ๊กเกอร์')}
                                            checked={this.state.material_worklist === 'สติ๊กเกอร์' ? true : false}
                                            label="สติ๊กเกอร์"
                                            type="radio"
                                            id="radio2"
                                            containerClass="mr-5"
                                          />
                                          {/* <MDBInput
                                            gap
                                            onClick={this.onClick(3)}
                                            checked={this.state.radio === 3 ? true : false}
                                            label="3"
                                            type="radio"
                                            id="radio3"
                                            containerClass="mr-5"
                                          /> */}
                                    </MDBFormInline>
                                </div>
                              </MDBCol>

                                          {this.state.material_worklist == 'ไวนิล' ?<>
                                          <MDBCol md="6">
                                            <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="tools" /> การติดตั้ง</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('พับเจาะ')}
                                                        checked={this.state.materialvinyl_worklist === 'พับเจาะ' ? true : false}
                                                        label="พับเจาะ"
                                                        type="radio"
                                                        id="radio4"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('พับไม่เจาะ')}
                                                        checked={this.state.materialvinyl_worklist === 'พับไม่เจาะ' ? true : false}
                                                        label="พับไม่เจาะ"
                                                        type="radio"
                                                        id="radio5"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดตั้ง/ติดโครง')}
                                                        checked={this.state.materialvinyl_worklist === 'ติดตั้ง/ติดโครง' ? true : false}
                                                        label="ติดตั้ง/ติดโครง"
                                                        type="radio"
                                                        id="radio6"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                                          </MDBCol>
                                          </> : <> 
                                          {this.state.material_worklist == 'สติ๊กเกอร์' ?<>
                                          <MDBCol md="6">
                                            <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="tools" /> การติดตั้ง</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ไม่ติด')}
                                                        checked={this.state.materialvinyl_worklist === 'ไม่ติด' ? true : false}
                                                        label="ไม่ติด"
                                                        type="radio"
                                                        id="radio7"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดฟิว')}
                                                        checked={this.state.materialvinyl_worklist === 'ติดฟิว' ? true : false}
                                                        label="ติดฟิว"
                                                        type="radio"
                                                        id="radio8"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดโฟม')}
                                                        checked={this.state.materialvinyl_worklist === 'ติดโฟม' ? true : false}
                                                        label="ติดโฟม"
                                                        type="radio"
                                                        id="radio9"
                                                        containerClass="mr-5"
                                                      />
                                                       <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ตัดแยกชิ้น')}
                                                        checked={this.state.materialvinyl_worklist === 'ตัดแยกชิ้น' ? true : false}
                                                        label="ตัดแยกชิ้น"
                                                        type="radio"
                                                        id="radio99"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                                          </MDBCol>
                                          </>:<>กรุณาเลือกประเภท</>}
                                          </>}

                            </MDBRow>
                           
                            <MDBRow>
                              <MDBCol md="12">
                              <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="newspaper" /> ชนิดกระดาษ</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPขาวเงา')}
                                                        checked={this.state.papertype_worklist === 'สติกเกอร์PPขาวเงา' ? true : false}
                                                        label="สติกเกอร์ PP ขาวเงา"
                                                        type="radio"
                                                        id="radio10"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPด้าน')}
                                                        checked={this.state.papertype_worklist === 'สติกเกอร์PPด้าน' ? true : false}
                                                        label="สติกเกอร์ PP ด้าน"
                                                        type="radio"
                                                        id="radio11"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPใส')}
                                                        checked={this.state.papertype_worklist === 'สติกเกอร์PPใส' ? true : false}
                                                        label="สติกเกอร์ PP ใส"
                                                        type="radio"
                                                        id="radio12"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์หลังเขียว')}
                                                        checked={this.state.papertype_worklist === 'สติกเกอร์หลังเขียว' ? true : false}
                                                        label="สติกเกอร์ หลังเขียว"
                                                        type="radio"
                                                        id="radio13"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์คราฟ')}
                                                        checked={this.state.papertype_worklist === 'สติกเกอร์คราฟ' ? true : false}
                                                        label="สติกเกอร์ คราฟ"
                                                        type="radio"
                                                        id="radio14"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด128g')}
                                                        checked={this.state.papertype_worklist === 'กระดาษอาร์ด128g' ? true : false}
                                                        label="กระดาษอาร์ด 128g"
                                                        type="radio"
                                                        id="radio15"
                                                        containerClass="mr-5"
                                                      />
                                                       <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด158g')}
                                                        checked={this.state.papertype_worklist === 'กระดาษอาร์ด158g' ? true : false}
                                                        label="กระดาษอาร์ด 158g"
                                                        type="radio"
                                                        id="radio16"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด260g')}
                                                        checked={this.state.papertype_worklist === 'กระดาษอาร์ด260g' ? true : false}
                                                        label="กระดาษอาร์ด 260g"
                                                        type="radio"
                                                        id="radio17"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด350g')}
                                                        checked={this.state.papertype_worklist === 'กระดาษอาร์ด350g' ? true : false}
                                                        label="กระดาษอาร์ด 350g"
                                                        type="radio"
                                                        id="radio18"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ดป็องแป้ง')}
                                                        checked={this.state.papertype_worklist === 'กระดาษอาร์ดป็องแป้ง' ? true : false}
                                                        label="กระดาษอาร์ด ป็องแป้ง"
                                                        type="radio"
                                                        id="radio19"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษคราฟ')}
                                                        checked={this.state.papertype_worklist === 'กระดาษคราฟ' ? true : false}
                                                        label="กระดาษ คราฟ"
                                                        type="radio"
                                                        id="radio20"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษเทกเจอร์')}
                                                        checked={this.state.papertype_worklist === 'กระดาษเทกเจอร์' ? true : false}
                                                        label="กระดาษเทกเจอร์"
                                                        type="radio"
                                                        id="radio21"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษA470g')}
                                                        checked={this.state.papertype_worklist === 'กระดาษA470g' ? true : false}
                                                        label="กระดาษA4 70g"
                                                        type="radio"
                                                        id="radio22"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                              </MDBCol>
                            </MDBRow>

                          
                            <MDBRow>
                              <MDBCol md="12">
                                <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="cut" /> ตัด</label>
                                  <MDBFormInline>
                                      <MDBInput
                                        gap
                                        onClick={this.onClickstatecut('ตัดแยกชิ้น')}
                                        checked={this.state.statecut_worklist === 'ตัดแยกชิ้น' ? true : false}
                                        label="ตัดแยกชิ้น"
                                        type="radio"
                                        id="radio23"
                                        containerClass="mr-5"
                                      />
                                      <MDBInput
                                        gap
                                        onClick={this.onClickstatecut('ไม่ตัด')}
                                        checked={this.state.statecut_worklist === 'ไม่ตัด' ? true : false}
                                        label="ไม่ตัด"
                                        type="radio"
                                        id="radio24"
                                        containerClass="mr-5"
                                      />
                                      {/* <MDBInput
                                        gap
                                        onClick={this.onClick(3)}
                                        checked={this.state.radio === 3 ? true : false}
                                        label="3"
                                        type="radio"
                                        id="radio3"
                                        containerClass="mr-5"
                                      /> */}
                                    </MDBFormInline>
                                </div>
                              </MDBCol>
                            </MDBRow>
                                        


                           

                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="primary" className="text-center"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form>
              </div>
<hr/>
              {persons}


              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
